<div
  *ngIf="!message.extMessage && !inherited && !isSystemMessage"
  [class.message-view__media-margin]="isMedia"
>
  <span class="author-info">
    <span class="author-name author message-view__author-name">{{
      author?.fullName || message.twilio.attributes.authorFriendlyName
    }}</span>
    <mat-chip
      class="call-sign-bubble"
      *ngIf="author?.callSign || message.twilio.attributes.authorCallSign"
    >
      <span class="call-sign">{{
        author?.callSign || message.twilio.attributes.authorCallSign
      }}</span>
    </mat-chip>
  </span>
  <sn-message-timestamp [message]="message"></sn-message-timestamp>
</div>

<div
  *ngIf="message.extMessage && !inherited && !isSystemMessage"
  [class.message-view__media-margin]="isMedia"
>
  <span class="author-info">
    <span class="author-name message-view__author-name">{{
      author?.fullName || message.twilio.attributes.authorFriendlyName
    }}</span>
    <mat-chip *ngIf="author?.callSign || message.twilio.attributes.authorCallSign">
      <span class="call-sign">{{
        author?.callSign || message.twilio.attributes.authorCallSign
      }}</span>
    </mat-chip>
    <span class="author-name message-view__author-name"
      >(<span class="message-view__org-truncate">{{ message.organization }}</span
      >)</span
    >
  </span>
  <sn-message-timestamp [message]="message"></sn-message-timestamp>
</div>

<sn-text-message
  *ngIf="!isMedia && message.twilio.attributes['type'] !== 'camera'"
  [text]="message.twilio.body"
  [isEdited]="!!message.twilio.lastUpdatedBy"
  [isSystemMessage]="isSystemMessage"
>
</sn-text-message>
<sn-camera-list-share
  *ngIf="isMultiCameras"
  [cameraIds]="message.twilio.attributes['cameras']"
></sn-camera-list-share>
<sn-media-message *ngIf="isMedia" [message]="message"></sn-media-message>
<sn-camera-share
  *ngIf="isCamera"
  [message]="message"
  [cameraId]="message.twilio.attributes['cameraId']"
></sn-camera-share>
